
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { debugLogger } from "@/utils/debugLogger";

export const useAuthOperations = (setLoading: (loading: boolean) => void) => {
  const signIn = async (email: string, password: string) => {
    try {
      debugLogger.log('AUTH', 'Sign in attempt', { email });
      setLoading(true);
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      
      if (error) throw error;
      debugLogger.log('AUTH', 'Sign in successful');
    } catch (error: any) {
      debugLogger.log('AUTH', 'Sign in failed', { error: error.message });
      toast.error(error.message || "Failed to sign in");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const signUp = async (email: string, password: string, fullName: string) => {
    try {
      debugLogger.log('AUTH', 'Sign up attempt', { email, fullName });
      setLoading(true);
      
      // Use the current origin for redirect URL
      const redirectUrl = `${window.location.origin}/auth/login`;
      
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: redirectUrl,
          data: {
            full_name: fullName,
          },
        },
      });
      
      if (error) throw error;
      
      debugLogger.log('AUTH', 'Sign up successful');
      toast.success("Signup successful! Please check your email for verification.");
    } catch (error: any) {
      debugLogger.log('AUTH', 'Sign up failed', { error: error.message });
      toast.error(error.message || "Failed to sign up");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const signOut = async () => {
    try {
      debugLogger.log('AUTH', 'Sign out attempt');
      setLoading(true);
      await supabase.auth.signOut();
      toast.success("Signed out successfully");
      debugLogger.log('AUTH', 'Sign out successful');
    } catch (error: any) {
      debugLogger.log('AUTH', 'Sign out failed', { error: error.message });
      toast.error(error.message || "Failed to sign out");
    } finally {
      setLoading(false);
    }
  };

  return {
    signIn,
    signUp,
    signOut
  };
};
